var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#666",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5.22 10.78a13.933 13.933 0 0 1-3.23-5.075c-.383-1.043-.033-2.188.753-2.974l.486-.485a1.406 1.406 0 0 1 1.99 0l1.139 1.138a1.407 1.407 0 0 1 0 1.991l-.28.28a1.207 1.207 0 0 0 0 1.707l2.56 2.56a1.205 1.205 0 0 0 1.707 0l.28-.28a1.408 1.408 0 0 1 1.992 0l1.138 1.139a1.405 1.405 0 0 1 0 1.991l-.486.485c-.785.786-1.93 1.136-2.973.754a13.933 13.933 0 0 1-5.076-3.23Z"
})));
export default SvgPhone;